export default __webpack_public_path__ + "static/media/banner-new.61172ba4.png";